import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/app';
import { BrowserRouter } from 'react-router-dom';

const renderApp = () => {
  ReactDOM.render(
  <BrowserRouter basename="/coachportal">
    <App />
  </BrowserRouter> ,
 document.getElementById('root')
  );
};

renderApp();